import actions from './actions'

const initialState = {
  loading: false,
  error: false,
  data: null,
  products: {
    loading: false,
    data: null,
  },
  shopifyProducts: {
    loading: false,
    data: null,
  },
  invoices: {
    loading: false,
    data: null,
  },
}

export default function subscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_PRODUCTS_STATE:
      return { ...state, products: { ...state.products, ...action.payload } }
    case actions.SET_SHOPIFY_PRODUCTS_STATE:
      return { ...state, shopifyProducts: { ...state.shopifyProducts, ...action.payload } }
    case actions.SET_INVOICES_STATE:
      return { ...state, invoices: { ...state.invoices, ...action.payload } }
    default:
      return state
  }
}
